/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import Footer from '../Footer';
import './Notification.sass';

const Notification = (props) => {
  const { logoPath, footerData } = props;

  return (
    <div className="main-wrapper">
      <div className="container">
        <header>
          <a href="/">
            <img className="logoImage" src={logoPath} alt="main logo" />
          </a>
        </header>
      </div>
      <div className="content-container">
        <div className="background-image" />
        <div className="container">
          <h2 className="main-color bold">{I18n.t('uncompleted_order.notification')}</h2>
        </div>
      </div>
      <Footer footerData={footerData} />
    </div>
  );
};

Notification.propTypes = {
  logoPath: PropTypes.string,
  footerData: PropTypes.oneOfType([PropTypes.object]),
};

Notification.defaultProps = {
  logoPath: '',
  footerData: {},
};

export default Notification;
